import React, { useEffect, useState, useRef } from 'react';
import '../index.css';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles } from '@material-ui/core/styles';
import { getDate, prospectDetailsPath,investmentDetailsPath ,searchFilter,handleSort } from "../utils/varialbles";

import { Select, MenuItem, TextField, RadioGroup, FormControl, FormControlLabel, Radio, Input,Paper } from '@material-ui/core';
import { useHistory, useRouteMatch,useLocation } from "react-router-dom";
import http from "../services/httpService";

import toast, { Toaster } from 'react-hot-toast';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: "#F5F7FA",
        padding: "7px"
    },
    paper: {
        paddingTop: theme.spacing(2),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    submitButton: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(10),


    },
    gridDevider: {
        marginTop: theme.spacing(6),
        textAlign: 'left',
        color: theme.palette.text.primary,
    },
    lableColor: {
        color: "#393939"
    },
    select: {
        height: 36,
        minWidth: 235,

    },
    mobileCode: {
        height: 36,
    },
    radio: {
        '&$checked': {
            color: '#57bf74'
        }
    },

    checked: {}

}));
function CreateNotification() {
    let history = useHistory();
    const [formObject, setFromObject] = useState({});
    let [lookupFile, setLookupFile] = useState(null);
    const classes = useStyles();
    const location = useLocation();
    const myparam = location.state;
    const [userName,setUserName] = useState(null)
    let form = {
        "type": "push",
        "id": null,
        "subject": "",
        "body": ""
    }
    const columns = [
        { "value": 'type', label: 'Notification Type', minWidth: 150, "filedType": "radio", "options": [{ "label": "Normal", "value": "notify" }, { "label": "Push", "value": "push" }] },
        { "value": 'subject', label: 'Subject', minWidth: 150, "filedType": "text" },
        { "value": 'body', label: 'Content', minWidth: 150, "filedType": "textarea", multiline: true, rows: 5 },
    ];
    useEffect(() => {
        if(myparam&&(myparam.cust__id||myparam.customer_id)){
            let cust_id = myparam.cust__id||myparam.customer_id;
            setUserName((myparam.cust__custfirstname||myparam.First_Name)+" "+(myparam.cust__custlastname||myparam.Last_Name))
            setFromObject({
                "type": "push",
                "id": cust_id,
                "subject": "",
                "body": ""
            })
        }else{
            history.goBack()
        }
        

    }, [])
    const handleChange = (event) => {
        setFromObject({
            ...formObject,
            [event.target.name]: event.target.value
        });
    }
    const handleFileChange = (event) => {
        setLookupFile(event.target.files[0])
        // setFromObject({
        //     ...formObject,
        //     [event.target.name]: event.target.files[0]
        // });
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        http.post("/notify", formObject,
        ).then((response) => {
            if(response.data.Data&&response.data.statusCode===0){
                toast.success(response.data.Data)
                gotoProspectDetails()
            }else{
                toast.error("Notification sending failed!");

            }
            // setFromObject(form)
        }).catch((error) => {
            // toast.error(error)
        })
    }
    const gotoProspectDetails = () => {
        if(myparam&&myparam.cust__id){
            history.push({
                "pathname": prospectDetailsPath, state: myparam
            });
        }else  if(myparam&&myparam.customer_id){
            history.push({
                "pathname": investmentDetailsPath, state: myparam
            });
        }else{
            history.goBack();
        }
        }
    return (

        <Grid container component="main">
            <Paper className={classes.root}>
            <Grid container>
                <Grid item xs={12} sm={6} md={3}>
                    <Button name="Overview" variant="contained" color="primary" onClick={gotoProspectDetails}>Overview</Button>
 
                </Grid>

            </Grid>
        </Paper>
            <Grid item xs={false} sm={5} md={5} style={{marginTop:30}}>
                <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={gotoProspectDetails}>Back</Button>
            </Grid>
            <Grid item xs={false} sm={5} md={5} style={{marginTop:30}}>
                <Typography  color="textPrimary" variant="h5" >Send notification to {userName}</Typography>
            </Grid>
            <Grid container style={{marginTop:30}}>
            {
                columns.map((question,inx) => {
                    return (
                        <Grid container className={classes.paper} key={inx+question.value}>
                            <Grid item xs={false} sm={2} md={2} >
                                <InputLabel className={classes.lableColor} id={question.lable}>{question.label}</InputLabel>
                            </Grid>
                            <Grid item lg={2} md={3} sm={3}>{question.filedType === "text" ?
                                <TextField label="Enter" variant="outlined" value={formObject[question.value]} name={question.value} onChange={handleChange} style={{width:335}}/> : question.filedType === "radio" ?
                                    <RadioGroup row aria-label="position" name={question.value} defaultValue="A" value={formObject[question.value] ? formObject[question.value] : "A"} onChange={handleChange}>
                                        {
                                            question.options.map((option,index) => {
                                                return (
                                                    <FormControlLabel key={index+option.value}
                                                        control={<Radio classes={{ root: classes.radio, checked: classes.checked }} value={option.value} />}
                                                        label={option.label}
                                                        labelPlacement="end"
                                                    />
                                                )
                                            })

                                        }


                                    </RadioGroup> : question.filedType === "file" ?
                                        <Input type="file" value={formObject[question.value]} name={question.value} onChange={handleFileChange} />
                                        : (question.filedType === "textarea") ? <TextField label="Enter" variant="outlined" value={formObject[question.value]} name={question.value} onChange={handleChange} multiline rows={question.rows} style={{width:335}}/> : ""}
                            </Grid>
                        </Grid>
                    )
                })
            }
            </Grid>
            <Grid container className={classes.submitButton}>
                <Grid item xs={false} sm={2} md={2} >

                </Grid>


                <Grid item xs={3} sm={2} md={2} >
                    <Button variant="contained" color="primary" onClick={handleSubmit}>Send Notification</Button>
                </Grid>
            </Grid>
        </Grid>
    )

}


export default CreateNotification;